<template>
  <div class="dashboard">
    <header class="dashboard__hero">
      <div class="dashboard__hero-brand">
        <div>
          <p class="dashboard__eyebrow">{{ $t("pages.dashboard.title") }}</p>
          <h1 class="dashboard__title" v-if="webUser">
            {{ $t("pages.dashboard.greeting") }}, {{ webUser }}
          </h1>
          <h1 class="dashboard__title" v-else>{{ $t("pages.dashboard.title") }}</h1>
        </div>
      </div>
      <div class="dashboard__date">
        <i class="far fa-calendar-alt" aria-hidden="true"></i>
        {{ todayLabel }}
      </div>
    </header>

    <section class="dashboard__section" v-if="hasWidgets">
      <div class="dashboard__widgets">
        <employee-pay-roll-for-sign-widget
          v-if="activeEmployeePayrolls"
          class="dashboard__widget"
        />
        <employee-vacation-day-widget v-if="showAvailableHolidays" class="dashboard__widget" />
        <employee-vacation-forecast-widget v-if="showForecastHolidays" class="dashboard__widget" />
        <hour-balance-widget v-if="activeHoursPack" class="dashboard__widget" />
      </div>
    </section>

    <section class="dashboard__section" v-if="activeEmployeePlanning">
      <div class="dashboard__section-head">
        <h2 class="dashboard__section-title">{{ $t("pages.dashboard.my_plan") }}</h2>
        <router-link :to="{ name: 'planning' }" class="dashboard__cta">
          {{ $t("pages.dashboard.month_plan") }}
          <span aria-hidden="true">→</span>
        </router-link>
      </div>

      <div class="dashboard__panel plan">
        <planning-calendar-component :type="typeWeekCalendar" />
      </div>
    </section>
  </div>
</template>

<script>
import EmployeePayRollForSignWidget from "@/pages/dashboard/widgets/EmployeePayRollForSignWidget.vue";
import EmployeeVacationDayWidget from "@/pages/dashboard/widgets/EmployeeVacationDayWidget.vue";
import EmployeeVacationForecastWidget from "@/pages/dashboard/widgets/EmployeeVacationForecastWidget.vue";
import { HourBalanceWidget } from "@/pages/employee/planning/widgets";
import { PlanningCalendarComponent } from "@/pages/employee/planning/components";
import { DATE_PERIOD_WEEK } from "@/components/form";

import { mapGetters } from "vuex";

export default {
  components: {
    HourBalanceWidget,
    PlanningCalendarComponent,
    EmployeePayRollForSignWidget,
    EmployeeVacationDayWidget,
    EmployeeVacationForecastWidget,
  },
  computed: {
    ...mapGetters("auth", [
      "activeHoursPack",
      "activeEmployeePayrolls",
      "activeEmployeePlanning",
      "showAvailableHolidays",
      "showForecastHolidays",
      "webUser",
    ]),
    typeWeekCalendar() {
      return DATE_PERIOD_WEEK;
    },
    hasWidgets() {
      return (
        this.activeEmployeePayrolls ||
        this.showAvailableHolidays ||
        this.showForecastHolidays ||
        this.activeHoursPack
      );
    },
    todayLabel() {
      try {
        return new Date().toLocaleDateString(this.$i18n.locale.replace("_", "-"), {
          weekday: "long",
          day: "numeric",
          month: "long",
        });
      } catch (e) {
        return new Date().toLocaleDateString();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./dashboard-portal.scss";

::v-deep .dashboard__widget.custom-card {
  width: 100% !important;
  min-width: 0 !important;
}

::v-deep .dashboard__panel .permission-calendar > .card {
  border: 1px solid var(--portal-border);
  box-shadow: none;
  background: var(--portal-surface-muted);
}

::v-deep .dashboard__panel .permission-calendar > h4 {
  display: none;
}

::v-deep .dashboard__panel .table-responsive {
  margin-top: 0.35rem;
}

::v-deep .dashboard__panel .plan-card {
  margin-left: auto !important;
  margin-right: auto !important;
}
</style>
